import React, { useState } from 'react';
import styled, { css } from 'styled-components';

interface AccordionProps {
  title: string;
  summary: string;
  subtitle?: string;
  onClick?: () => void;
  useAdditionalAddress?: boolean;
}

interface AccordionContainerProps {
  isCollapsed: boolean;
}

const AccordionContainer = styled.div<AccordionContainerProps>`
  margin-bottom: 16px;
  transition: max-height 0.3s ease;

  ${props =>
    props.isCollapsed &&
    css`
      .accordion-summary {
        max-height: 0;
      }
    `}
`;

const AccordionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: transform 0.3s ease;
`;

const AccordionTitle = styled.div`
  color: var(--primary-blue-6, #183558);
  font-size: 14px;
  font-family: Brandon Text;
  font-weight: bold;
  line-height: 16px;
  text-transform: uppercase;
  transition: transform 0.3s ease;
`;

const AccordionSubtitle = styled.div`
  color: var(--neutral-gray-5, #6d7184);
  font-size: 14px;
  font-family: Brandon Text;
  font-weight: 390;
  line-height: 20px;
  margin-top: 8px;
`;

const AccordionIcon = styled.div`
  color: var(--primary-blue-2, #00aedd);
  font-size: 14px;
  font-family: Brandon Text;
  font-weight: 390;
  line-height: 20px;
  transition: transform 0.3s ease;
`;

const AccordionSummary = styled.div`
  margin-top: 8px;
  transition: max-height 0.3s ease;
`;

const Accordion: React.FC<AccordionProps> = ({
  title,
  summary,
  subtitle,
  onClick,
  useAdditionalAddress = true
}) => {
  const [isCollapsed, setIsCollapsed] = useState(
    useAdditionalAddress ? false : true
  );

  const handleAccordionToggle = () => {
    setIsCollapsed(!isCollapsed);
    onClick?.();
  };

  const handleIconKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      onClick?.(setIsCollapsed(!isCollapsed));
    }
  };

  return (
    <AccordionContainer isCollapsed={isCollapsed}>
      <AccordionHeader
        onClick={handleAccordionToggle}
        tabIndex={0}
        onKeyDown={handleIconKeyDown}
      >
        <AccordionTitle>{title}</AccordionTitle>
        <AccordionIcon onClick={onClick}>
          {isCollapsed ? 'Edit' : 'Use registration address'}
        </AccordionIcon>
      </AccordionHeader>
      {isCollapsed && subtitle && (
        <AccordionSubtitle>{subtitle}</AccordionSubtitle>
      )}
      <AccordionSummary className="accordion-summary">
        {isCollapsed ? null : <div>{summary}</div>}
      </AccordionSummary>
    </AccordionContainer>
  );
};

export default Accordion;
